module.exports = __webpack_public_path__ + "assets/images/popups/alert_bg_short.jpg";